import { render, staticRenderFns } from "./Medicacoes.vue?vue&type=template&id=1de11c79&"
import script from "./Medicacoes.vue?vue&type=script&lang=js&"
export * from "./Medicacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports